import { createNativeStackNavigator } from '@react-navigation/native-stack'
import React from 'react'

import { Chat } from 'pages/Chat'

import { links } from 'utils/constants'

export type ChatStackParamList = {
  [links.CHAT_PAGE]: any
}

const Stack = createNativeStackNavigator<ChatStackParamList>()

export const ChatStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: true,
        title: 'Chat',
      }}
    >
      <Stack.Screen name={links.CHAT_PAGE} component={() => <Chat withBack={false} />} />
    </Stack.Navigator>
  )
}
